module.exports = __webpack_public_path__ + "img/shekel-sign.8e400024.svg";